<script lang="ts" setup>
import { useAppStore } from "@/store/app.store";
import { OrdersMixin } from "@/views/orders/orders.mixin";
import { useDateTime } from "@/composables";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    timeType: string;
    timeTo: string | null | undefined;
    stopTimezone: string | undefined;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const appStore = useAppStore();
const orderUtils = OrdersMixin.methods!;
const { dateTZ } = useDateTime();

function getTimeWithTZ(time: string | undefined | null, timezone: string | undefined) {
  if (!timezone || !time) {
    return "";
  }

  return dateTZ(time, timezone);
}

const textDisabledClass = computed(() => {
  return {
    "text-grey": props.disabled,
  };
});
</script>

<template>
  <div>
    <div
      v-if="appStore.dispatcher"
      class="font-size-12 font-weight-500 text-grey-darken-3 mb-1 text-uppercase"
      data-qa="next-stop-time1"
    >
      <span :class="textDisabledClass">
        {{ orderUtils.getTimeType(props.timeType) }}:
        {{ getTimeWithTZ(props?.timeTo, appStore.dispatcher.timezone) }}
      </span>
    </div>

    <div class="font-size-12 text-grey-darken-1 mb-2 text-uppercase" data-qa="next-stop-time2">
      <span :class="textDisabledClass">
        {{ orderUtils.getTimeType(props?.timeType) }}:
        {{ getTimeWithTZ(props?.timeTo, props?.stopTimezone) }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
